import { Box } from '@factorialco/deprecated-design-system'
import { TimePlanningBalance, TimePlanningBalancesByPeriod } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import Loading from 'modules/core/components/Loading'

import type { ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import useFetchPlannedBreaks from 'modules/shift_management/hooks/useFetchPlannedBreaks'
import useFetchSwapShifts from 'modules/shift_management/hooks/useFetchSwapShifts'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import type { ShiftsRow, View } from 'modules/shift_management/lib/types'
import { SwapShiftsProvider } from 'modules/shift_management/store/internal/collections/SwapShifts'
import { PlannedBreaksProvider } from 'modules/time_planning/store/internal/collections/plannedBreaks'

import DataTable from './DataTable'

interface BodyProps {
  isLoading: boolean
  shiftsRows: ShiftsRow[]
  view: View
  showCoverageSection: boolean
  contractVersions: ContractVersions
  balancesByEmployee: Record<string, TimePlanningBalance>
  periodBalancesByEmployee: Record<string, TimePlanningBalancesByPeriod[]>
}

const Body = ({
  isLoading,
  shiftsRows,
  view,
  showCoverageSection,
  contractVersions,
  balancesByEmployee,
  periodBalancesByEmployee,
}: BodyProps) => {
  const [{ shiftsToQuery }] = useSchedule()
  // TODO: Remove this hook once 'dev_shift_management_graphql_migration' is done
  const { plannedBreaks } = useFetchPlannedBreaks(shiftsToQuery, view)
  const { swapShifts } = useFetchSwapShifts(shiftsToQuery, view)

  if (isLoading) {
    return (
      <Box flexGrow background="grey000White">
        <Loading />
      </Box>
    )
  }

  return (
    <PlannedBreaksProvider collection={plannedBreaks}>
      <SwapShiftsProvider collection={swapShifts}>
        <DataTable
          shiftsRows={shiftsRows}
          balancesByEmployee={balancesByEmployee}
          periodBalancesByEmployee={periodBalancesByEmployee}
          view={view}
          showCoverageSection={showCoverageSection}
          contractVersions={contractVersions}
        />
      </SwapShiftsProvider>
    </PlannedBreaksProvider>
  )
}

export default observer(Body)
